const VaticanCitySvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_112768)">
      <path
        d="M20.0003 0C31.0459 0 40.0003 8.95437 40.0003 20C40.0003 31.0456 31.0459 40 20.0003 40C20.0003 39.1305 17.3916 20 17.3916 20L20.0003 0Z"
        fill="#F0F0F0"
      />
      <path d="M20 40C8.95437 40 0 31.0456 0 20C0 8.95437 8.95437 0 20 0" fill="#FFDA44" />
      <path
        d="M27.659 17.4038L31.4177 22.3762C30.8255 23.2729 30.8286 24.481 31.5135 25.387C32.3823 26.5363 34.0183 26.7638 35.1677 25.895C36.317 25.0262 36.5445 23.3902 35.6755 22.2409C34.9908 21.3349 33.8292 21.0024 32.805 21.3276L26.9471 13.5781L25.5598 14.6269L23.4785 16.1998L25.576 18.9745L27.659 17.4038ZM33.0702 23.1202C33.4533 22.8305 33.9987 22.9065 34.2883 23.2895C34.5778 23.6726 34.5021 24.218 34.119 24.5077C33.7359 24.7971 33.1905 24.7215 32.901 24.3383C32.6112 23.9552 32.6871 23.4098 33.0702 23.1202Z"
        fill="#ACABB1"
      />
      <path
        d="M34.1058 18.9746L36.2033 16.2L34.1222 14.6269L32.7348 13.5781L26.8769 21.3276C25.8529 21.0024 24.6912 21.335 24.0064 22.2409C23.1375 23.3903 23.365 25.0263 24.5143 25.895C25.6637 26.7638 27.2996 26.5363 28.1683 25.387C28.8532 24.481 28.8563 23.2729 28.2642 22.3762L32.0229 17.4038L34.1058 18.9746ZM26.781 24.3384C26.4915 24.7216 25.9462 24.7973 25.563 24.5078C25.1799 24.2181 25.1041 23.6727 25.3937 23.2896C25.6833 22.9066 26.2287 22.8307 26.6119 23.1204C26.9949 23.41 27.0706 23.9554 26.781 24.3384Z"
        fill="#FFDA44"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_112768">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default VaticanCitySvg;
